module.exports = __webpack_public_path__ + "img/maximum.a7692df9.svg";